import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberDetailsClaimsEntityWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberDetailsClaimsEntityWidgetService } from 'services/memberDetailsClaimsEntityWidget';
 *
 * // create service instance and send/cancel request
 * const memberDetailsClaimsEntityWidgetService = new MemberDetailsClaimsEntityWidgetService();
 * const result = await memberDetailsClaimsEntityWidgetService.fetchData( '<user-id>' ); // fetch data
 * memberDetailsClaimsEntityWidgetService.cancel(); // cancel an active request
 */
export class MemberDetailsClaimsEntityWidgetService extends HttpService {

    // make request and fetch data
    async fetchData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
                data: get( response, 'body.component', {} ),
            };
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }

    // function to fetch claim reversal info
    async fetchClaimReversalInfo ( { url = {}, data = {} } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
                data: {
                    options: get( response, 'body.component.data.options', {} ),
                    state: get( response, 'body.component.data.state', {} ),
                    ...get( response, 'body.component.structure', {} ),

                    // actions: get( response, 'body.component.structure.actions', {} ),
                    // fields: get( response, 'body.component.structure.fields', {} ),
                    // primaryColumns: get( response, 'body.component.structure.primaryColumns', {} )
                }
            };
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
